import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlannerMenuIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 12 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M1 12.9561C1 14.3209 1.66281 15 2.99485 15h6.01673C10.3372 15 11 14.3209 11 12.9561V3.05037C11 1.69217 10.3372 1 9.01158 1H2.99485C1.66281 1 1 1.69217 1 3.05037v9.90573Zm3.35265-9.69677c-.2381 0-.43759-.1959-.43759-.4375s.19949-.4375.43759-.4375h3.29474c.24453 0 .43754.1959.43754.4375s-.19301.4375-.43754.4375H4.35265Z"
	})
});
export default SvgPlannerMenuIcon;
